import { intakeHref } from '../lib/referral';
import React from 'react';
import { ArrowRight } from 'lucide-react';

const HERO_IMG = 'https://static.prod-images.emergentagent.com/jobs/610c4df3-c93d-47d4-bfca-d4436f2640bc/images/74fdd8db15df4765669af0ea561a5020808ed4bddcee4cc1c0249cbce98312d5.jpeg';
const DOCTOR_IMG = 'https://static.prod-images.emergentagent.com/jobs/610c4df3-c93d-47d4-bfca-d4436f2640bc/images/48cc2d54f77bcac3ef46603eb9ccfccabe95979134a077f2344f3bb1a584edf7.jpeg';
const BOX_IMG = '/images/hero-product-box.webp';

const FloatCard = ({ className, testId, title, body, img, imgClass }) => (
  <div data-testid={testId} className={`glass-card absolute hidden items-center gap-5 p-4 pr-5 rounded-2xl ${className}`}>
    <img src={img} alt="" className={imgClass} />
    <div className="min-w-0">
      <p className="text-[17px] text-[color:var(--alfa-ink)]">{title}</p>
      <p className="mt-1 text-[13px] text-[color:var(--alfa-muted)]">{body}</p>
      <span className="mt-3 block h-[2px] w-8 bg-[color:var(--alfa-gold)]" />
    </div>
    <span className="ml-auto self-end w-8 h-8 rounded-full border border-neutral-900/20 flex items-center justify-center shrink-0">
      <ArrowRight size={13} />
    </span>
  </div>
);

export default function Hero() {
  return (
    <section data-testid="hero" className="relative overflow-hidden bg-[color:var(--alfa-cream)]">
      <div className="relative lg:absolute lg:inset-y-0 lg:right-0 lg:w-[66%] h-[420px] sm:h-[520px] lg:h-auto hero-image-in">
        <img src={HERO_IMG} alt="Smiling woman at home holding her phone" className="w-full h-full object-cover object-[70%_center]" />
        <div className="absolute inset-0 hero-photo-fade" />
        <FloatCard testId="hero-card-care-team" className="2xl:flex top-[20%] left-[22%] w-[340px]" title="Your care team" body="Ongoing support from your care team." img={DOCTOR_IMG} imgClass="w-[84px] h-[84px] rounded-full object-cover shrink-0" />
        <FloatCard testId="hero-card-treatment-plan" className="xl:flex bottom-[12%] right-[4%] w-[410px]" title="Your treatment plan" body="Personalized. Provider reviewed." img={BOX_IMG} imgClass="w-[120px] h-[84px] rounded-lg object-cover shrink-0" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-[72px] pt-10 pb-14 lg:pt-[150px] lg:pb-[70px] -mt-24 lg:mt-0">
        <div className="max-w-[560px]">
          <p className="eyebrow hero-kicker-in" data-testid="hero-eyebrow">Personalized weight-loss care</p>
          <h1 className="hero-headline-in mt-6 text-[48px] sm:text-[64px] lg:text-[84px] leading-[0.98] tracking-[-0.035em] font-light text-[color:var(--alfa-ink)]">
            Physician-led<br />GLP-1 weight<br />loss care.
          </h1>
          <p className="hero-sub-in mt-7 text-[19px] sm:text-[22px] leading-[1.45] text-[color:var(--alfa-ink)]">
            Licensed providers evaluate your health history <span className="text-[color:var(--alfa-muted)]">to determine whether treatment is medically appropriate.</span>
          </p>
          <div className="hero-sub-in mt-5" data-testid="hero-flat-price">
            <p className="text-[16px] sm:text-[17px] font-medium text-[color:var(--alfa-ink)]">One flat monthly price&mdash;even as your prescribed dose changes.</p>
          </div>
          <a href={intakeHref()} target="_blank" rel="noopener noreferrer" data-testid="hero-start-visit-btn" className="hero-cta1-in btn-primary mt-7 inline-flex items-center gap-3 text-[17px] px-7 py-4 rounded-md">
            Start your online visit <ArrowRight size={18} />
          </a>
          <div data-testid="hero-trust-line" className="hero-cta2-in mt-7 sm:mt-6 grid grid-cols-3 divide-x divide-neutral-900/25 sm:divide-x-0 sm:flex sm:flex-wrap sm:items-center sm:gap-x-4 sm:gap-y-1 text-[15px] leading-[1.25] sm:leading-normal sm:text-[13px] italic font-semibold sm:font-normal text-center sm:text-left text-[#4a433b] sm:text-[color:var(--alfa-muted)]">
            <span className="px-2 sm:px-0 flex items-center justify-center">Licensed U.S. doctors</span>
            <span className="hidden sm:inline">&bull;</span>
            <span className="px-2 sm:px-0 flex items-center justify-center">No insurance needed</span>
            <span className="hidden sm:inline">&bull;</span>
            <span className="px-2 sm:px-0 flex items-center justify-center">Cancel anytime</span>
          </div>
        </div>
      </div>
    </section>
  );
}
